export default [
    {
        id: 1,
        type: 'link',
        owner: 'dfc',
        name: 'Link',
        color: '#889098',
        data: {
            preview_url: '',
            url: 'https://google.com'
        },
    },
    {
        id: 2,
        type: 'file-pdf',
        owner: 'dfc',
        name: 'PDF Document',
        color: '#20CE83',
        data: {
            preview_url: '',
            url: 'http://www.africau.edu/images/default/sample.pdf'
        },
    },
    {
        id: 3,
        type: 'file-image',
        owner: 'dfc',
        name: 'Image',
        color: '#20CE83',
        data: {
            preview_url: 'https://img.freepik.com/free-vector/group-people-illustration-set_52683-33806.jpg?size=320&ext=jpg',
            url: 'https://img.freepik.com/free-vector/group-people-illustration-set_52683-33806.jpg'
        },
    },
];
